export const getGlobalAndFacilityEncKeyFromContext = (
  facilityContext: any,
  facility_id?: string | number
) => {
  const {
    facilityAndGlobalEncKeys: {
      globalEncKey = '',
      facilityEncPublicKeysPerFid: {
        [facility_id || '']: facPublicKey = '',
      } = {},
    } = {},
  } = facilityContext;
  return { globalEncKey, facPublicKey };
};
